import { z } from "zod";
import { RESOURCE_LABEL_MAX_LENGTH } from "@/other/constants/OtherKeys";

export const resourceSchema = z.object({
  name: z.string().min(1, "Resource ID is required").max(RESOURCE_LABEL_MAX_LENGTH, `Resource ID must be ${RESOURCE_LABEL_MAX_LENGTH} characters or less`),
  description: z.string().optional().or(z.literal("")),
  location: z.string().max(500, "Location must be less than 500 characters").optional().or(z.literal("")),
  statusId: z.number().optional().nullable(),
  categoryId: z.number().optional().nullable(),
  teamId: z.number().optional().nullable(),
  tagsId: z.array(z.number()).optional().nullable(),
  iconId: z.number().optional().nullable(),
  typeId: z.number().optional().nullable(),
  jobTitle: z.string().max(255, "Sub Type must be less than 255 characters").optional().or(z.literal(""))
});

export type ResourceFormData = z.infer<typeof resourceSchema>;
